import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import About from "../pages/about/page";
import Downloads from "../pages/downloads/page";
import Contact from "../pages/contact/page";
import News from "../pages/news/page";
import Impressum from "../pages/impressum/page";
import Datenschutz from "../pages/datenschutz/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/downloads",
    element: <Downloads />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/impressum",
    element: <Impressum />,
  },
  {
    path: "/datenschutz",
    element: <Datenschutz />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;